module.exports = __webpack_public_path__ + "img/photo-lifestyle-location.cd24b22d.png";